<template id="chessground">
  <div class="actions-field">
    <Chess
      v-bind:state="modelElement.state"
      v-bind:sweets="modelElement.sweets"
      v-bind:dimension="dimension"
      v-bind:actions="modelElement.actions"
      v-bind:figureType="figureType"
    />
    <div class="actions-rating">
      <svg :width="dimension" :height="dimension">
        <g v-for="(sweet, index) in modelElement.sweets" :key="index">
          <circle
            class="circle-element"
            @click="handleClick(modelElement.state, index)"
            :cx="(dimension / 4) * index + 10"
            :cy="(dimension / 2) * (0 - 1) + dimension"
            r="10"
            :fill="
              sweet > 0 ? colorsActive[index].fill : colorsInactive[index].fill
            "
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import Chess from './chess.vue'
export default {
  name: 'PossibleActions',
  components: {
    Chess,
  },
  props: {
    index: Number,
    currentState: Boolean,
    chosenPlayType: Number,
    figureType: Number,
  },
  data: function() {
    return {
      colorsActive: [
        { name: 'url(#arrow-blue)', hex: '#00f', fill: 'blue' },
        { name: 'url(#arrow-red)', hex: '#f00', fill: 'red' },
        { name: 'url(#arrow-green)', hex: '#0f0', fill: 'green' },
        { name: 'url(#arrow-yellow)', hex: '#ffa500', fill: 'orange' },
        { name: 'url(#arrow-purple)', hex: '#80f', fill: 'purple' },
      ],
      colorsInactive: [
        { name: 'url(#arrow-blue)', hex: '#00f', fill: '#000DFF55' },
        { name: 'url(#arrow-red)', hex: '#f00', fill: '#FF000055' },
        { name: 'url(#arrow-green)', hex: '#0f0', fill: '#3B652155' },
        { name: 'url(#arrow-yellow)', hex: '#ffa500', fill: '#C99E3655' },
        { name: 'url(#arrow-purple)', hex: '#80f', fill: '#000' },
      ],
      dimension: 90,
    }
  },
  computed: {
    modelElement: function() {
      return this.$store.getters.getObjectForStateIndex(this.index)
    },
  },
  methods: {
    handleClick(state, index) {
      this.$store.commit('update', { state: state, index: index })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.actions-field {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 1fr;
  padding: 0.2em;
  border: 1px solid lightgray;
}

.circle-element:hover {
  cursor: pointer;
}
</style>
